(() => {
  if (customElements.get('wm-article-editorial')) return;

  // Text-based IDs stay stable across reloads and unrelated heading insertions.
  function slug(text) {
    return text.toLocaleLowerCase('tr').normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i')
      .replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'bolum';
  }

  class EditorialArticle extends HTMLElement {
    connectedCallback() {
      // Deferred script and editor-inserted sections both have their children available.
      this.initialize();
    }

    initialize() {
      const content = this.querySelector('[data-editorial-content]');
      const title = this.querySelector('[data-editorial-title]');
      const toc = this.querySelector('[data-editorial-toc]');
      if (!content || !title || !toc) return;
      const headings = [...content.querySelectorAll('h2, h3')]
        .filter((heading) => heading.textContent.trim());
      toc.hidden = !headings.length;
      this.classList.toggle('editorial--has-toc', Boolean(headings.length));
      if (!headings.length) return;

      const ids = new Map();
      document.querySelectorAll('[id]').forEach((node) => {
        ids.set(node.id, (ids.get(node.id) || 0) + 1);
      });
      // Keep unique, non-whitespace authored anchors, including non-Latin IDs.
      headings.forEach((heading) => {
        if (heading.id && !/\s/.test(heading.id) && ids.get(heading.id) === 1) return;
        const base = `article-${slug(heading.textContent)}`;
        let id = base;
        let suffix = 2;
        while (ids.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        ids.set(id, 1);
      });

      this.querySelectorAll('[data-editorial-list]').forEach((list) => {
        list.replaceChildren();
        const appendLink = (target, parent) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(target.id)}`;
          link.textContent = target.textContent.trim();
          item.append(link);
          parent.append(item);
          return item;
        };
        appendLink(title, list);
        let parentHeading = null;
        let children = null;
        headings.forEach((heading) => {
          if (heading.tagName === 'H3' && parentHeading) {
            if (!children) {
              children = document.createElement('ul');
              parentHeading.append(children);
            }
            appendLink(heading, children);
          } else {
            const item = appendLink(heading, list);
            parentHeading = heading.tagName === 'H2' ? item : null;
            children = null;
          }
        });
      });

      this.onclick = (event) => {
        const link = event.target.closest('[data-editorial-toc] a');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;
        // Keep native history/hash behavior; move keyboard focus to the reading destination.
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };

      // The browser's first fragment pass may precede generated IDs.
      if (location.hash) {
        let target;
        try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
        if (target && content.contains(target)) target.scrollIntoView();
      }
    }

    disconnectedCallback() {
      this.onclick = null;
    }
  }

  // Custom elements reconnect automatically on Shopify section replacement; no global listeners.
  customElements.define('wm-article-editorial', EditorialArticle);
})();
